import { jsx as _jsx } from "react/jsx-runtime";
import { memo, forwardRef } from 'react';
import { ErrorBoundary, } from 'react-error-boundary';
import { FullScreenProvider, RootLayout } from 'react-science/ui';
import ErrorOverlay from './ErrorOverlay';
import { InnerNMRium } from './InnerNMRium';
const NMRiumBase = forwardRef(function NMRium(props, ref) {
    const { noErrorBoundary = false, onError, ...otherProps } = props;
    const innerNmrium = _jsx(InnerNMRium, { ...otherProps, innerRef: ref });
    const children = noErrorBoundary ? (innerNmrium) : (_jsx(ErrorBoundary, { FallbackComponent: ErrorOverlay, onError: onError, children: innerNmrium }));
    return (_jsx(FullScreenProvider, { children: _jsx(RootLayout, { style: { width: '100%' }, children: children }) }));
});
export const NMRium = memo(NMRiumBase);
